import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Row, Button, Spinner, Badge } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { useNavigate } from 'react-router-dom';
import Whoweareservice from '../../../services/KangarooServices/Whoweareservice';
import toast from 'react-hot-toast';
import { imageBaseApi } from '../../../utilis/imageHelper';
import DeleteModal from '../../../Components/Common/DeleteModal';


const Whoweare = () => {
  const navigate = useNavigate();
  const [whoWeAreList, setWhoWeAreList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  
  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await Whoweareservice.delete(selectedDeleteItem.id);
        await fetchWhoWeAreList();
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Page"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  

  const fetchWhoWeAreList = async () => {
    try {
      setLoading(true);
      const response = await Whoweareservice.getList();
      setWhoWeAreList(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load data');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWhoWeAreList();
  }, []);

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this item?')) {
//       return;
//     }

//     try {
//       setDeleteLoading(id);
//       await Whoweareservice.delete(id);
//       toast.success('Deleted successfully');
//       // Refresh the list after deletion
//       fetchWhoWeAreList();
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.response?.data?.message || 'Failed to delete');
//     } finally {
//       setDeleteLoading(null);
//     }
//   };

  const handleEdit = (slug) => {
    navigate(`/who-we-are/update/${slug}`);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Who We Are" pageTitle="Content Management" />

        {/* <Row className="mb-3">
          <Col className="d-flex justify-content-end">
            <Button
              color="success"
              onClick={() => navigate('/who-we-are/create')}
            >
              <i className="bi bi-plus-lg me-2"></i>
              Add New
            </Button>
          </Col>
        </Row> */}

        {loading ? (
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="text-center py-5">
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                    <p className="mt-3 text-muted">Loading data...</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : whoWeAreList.length === 0 ? (
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="text-center py-5">
                    <i className="ri-file-list-line display-1 text-muted"></i>
                    <h5 className="mt-4 mb-2">No Data Found</h5>
                    <p className="text-muted mb-4">Get started by creating your first Who We Are entry</p>
                    <Button
                      color="primary"
                      onClick={() => navigate('/who-we-are/create')}
                    >
                      <i className="bi bi-plus-lg me-2"></i>
                      Create First Entry
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row>
            {whoWeAreList.map((item, index) => (
              <Col xl={4} lg={6} md={6} sm={12} key={item.id} className="mb-4">
                <Card className="h-100 shadow-sm" onClick={()=>navigate(`/who-we-are/details/${item.slug}`)} style={{cursor:"pointer"}}>
                  <CardBody>
                    {/* Banner Image */}
                    <div className="position-relative mb-3">
                      {item.media ? (
                        <img
                          src={`${imageBaseApi}${item.media.url}`}
                          alt="Banner"
                          className="img-fluid rounded"
                          style={{
                            width: '100%',
                            height: '180px',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <div
                          className="d-flex align-items-center justify-content-center bg-light rounded"
                          style={{
                            width: '100%',
                            height: '180px',
                          }}
                        >
                          <i className="ri-image-line display-4 text-muted"></i>
                        </div>
                      )}
                      
                      
                    </div>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                            <small className="text-muted">
                              {item.slug || "-"}
                            </small>
                    </div>

                    {/* Banner Text */}
                    <h5 className="text-level-0 mb-3 fw-bold" style={{ color: `${item?.bannerColor}` }}>
                            {item.bannerText}
                          </h5>
                    {/* <div className="mb-3">
                      <p
                        className="mb-0 text-truncate"
                        title={item.bannerText}
                      >
                        {item.bannerText || 'No banner text available'}
                      </p>
                    </div> */}

                    <h6
                        className="mb-2"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                        dangerouslySetInnerHTML={{
    __html: item?.content,
  }}
                      >
                        
                      </h6>

                    {/* Banner Color */}
                    <div className="mb-3">
                      <h6 className="text-muted small mb-2">Banner Color</h6>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded border"
                          style={{
                            width: '50px',
                            height: '50px',
                            backgroundColor: item.bannerColor || '#000',
                          }}
                        ></div>
                        <Badge color="light" className="text-dark">
                          {item.bannerColor || 'N/A'}
                        </Badge>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex gap-2 mt-3 pt-3 border-top">
                      <Button
                        color="warning"
                        size="sm"
                        className="flex-fill"
onClick={(e) => {
    e.stopPropagation();
    handleEdit(item.slug);
  }}                      >
                        <i className="ri-pencil-line me-1"></i>
                        Edit
                      </Button>
                      <Button
                        color="primary"
                        size="sm"
                        outline
                        className="flex-fill"
                        onClick={()=>navigate(`/who-we-are/details/${item.slug}`)} style={{cursor:"pointer"}}>
                        
                            <i className="ri-eye-line me-1"></i>
                            Details
                          
                        
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <DeleteModal
                show={isOpenDelete}
                onCloseClick={toggleDelete}
                onDeleteClick={handleDelete}
              />
      </Container>
    </div>
  );
};

export default Whoweare;